<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="19"
    viewBox="0 0 15 19"
  >
    <g transform="translate(-14.615 0.001)">
      <g transform="translate(14.615 -0.001)">
        <path
          d="M17.028,15.261l-1.585,2.195a.976.976,0,0,0,.212,1.357A.96.96,0,0,0,17,18.6l1.6-2.212a7.406,7.406,0,0,0,3.516.884A7.564,7.564,0,0,0,27.335,4.3l1.989-2.753A.977.977,0,0,0,29.112.185.959.959,0,0,0,27.764.4L25.79,3.131a7.406,7.406,0,0,0-3.675-.974,7.564,7.564,0,0,0-5.087,13.1ZM27.686,9.714a5.6,5.6,0,0,1-5.571,5.614,5.5,5.5,0,0,1-2.362-.537l6.429-8.9A5.609,5.609,0,0,1,27.686,9.714ZM22.115,4.1a5.5,5.5,0,0,1,2.528.618l-6.471,8.958A5.619,5.619,0,0,1,22.115,4.1Z"
          transform="translate(-14.615 0.001)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "cancel-icon.vue",
};
</script>

<style scoped></style>
